import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import moment from 'moment';
import Loading from '../Loading/Loading';
import lottie from 'lottie-web';

const FirstBonus = ({ siteId, mallId, liffAccessToken, firstbonus, closeClick }) => {
  const [lockData, setLockData] = useState(true);
  const [lotteryLesult, setLotteryLesult] = useState(null);
  const [messageData, setMessageData] = useState(null);
  const [pointData, setPointData] = useState(null);

  const refreshData = useCallback(async () => {
    try {
      const nowdate = moment().format('YYYYMMDD');
      //抽選結果取得
      if (firstbonus && firstbonus.bonus_start <= nowdate && firstbonus.bonus_end >= nowdate) {
        const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/firstbonus/line/lottery/`, { site_id: siteId, mall_id: mallId, line_id: liffAccessToken })).data;
        console.log(data)
        setLotteryLesult((data && data.data ? data.data.lottery : null))
        if (data && data.data) setPointData(data.data);
        if (data && data.msg) setMessageData(data.msg);
      }else{
        setMessageData("キャンペーンは終了しました。")
      }

    } catch (err) {
      console.log(err);
    } finally {
      setLockData(false);
    }
  }, [siteId, mallId, liffAccessToken, firstbonus]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  useEffect(() => {
    if (lotteryLesult !== null) {
      const container = document.querySelector(lotteryLesult ? '[data-lottie-lucky-v2]' : '[data-lottie-miss-v2]');
      if (container) {
        lottie.loadAnimation({
          container: container,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          path: lotteryLesult ? `/${siteId}/lottie-lucky-v2.json` : `/${siteId}/lottie-miss-v2.json`
        });
      }
    }
  }, [lotteryLesult, siteId]);
  return (
    <div id="membershippass" className="px-0-env">
      <div className="item">
        {lockData && <Loading />}
        {lotteryLesult === true &&
          <React.Fragment>
            <div data-lottie-lucky-v2></div>
            <div className='col-12 text-center'>{messageData ? messageData : ""}</div>
            <div className='col-12 text-center'>{(pointData && pointData.point) && <>有効期限：{moment(pointData.expire_date).format('YYYY/MM/DD')}</>}</div>
          </React.Fragment>
        }
        {lotteryLesult === false &&
          <React.Fragment>
            <div data-lottie-miss-v2></div>
            <div className='col-12 text-center'>{messageData ? messageData : ""}</div>
          </React.Fragment>
        }
        {(lotteryLesult === null && messageData) &&
          <div className='col-12 text-center'>
            {messageData}
          </div>}
          <button className="button text-black bg-lightwhite" onClick={e => closeClick()}>会員証を表示</button>
      </div>
    </div>
  );
}
export default FirstBonus;